import { render, staticRenderFns } from "./VacationsRejectedDayLegend.vue?vue&type=template&id=52ac5686&"
import script from "./VacationsRejectedDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationsRejectedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports